import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { RouteErrorComponent } from '@/features/app-shell/route-error-component'
import {
	Section,
	SectionDescription,
	SectionTitle,
} from '@/features/app-shell/section'

import { getCurrentSKU } from '@/shared/auth/store'

import { Skeleton } from '@/components/ui/skeleton'

export const Route = createFileRoute('/_dashboard/report')({
	beforeLoad: ({ location }) => {
		const sku = getCurrentSKU()

		// If it is on main page and the sku is not search enabled, redirect to home
		if (location.pathname === '/report') {
			if (sku && !sku.is_search_enabled) {
				throw redirect({
					to: '/home',
				})
			}

			throw redirect({
				to: '/report/air',
			})
		}
	},

	head: () => ({
		meta: [
			{
				title: 'Reports | BitLyft AIR®',
			},
		],
	}),

	component: ReportRoute,
	pendingComponent: ReportPending,
	errorComponent: RouteErrorComponent,
})

function ReportRoute() {
	return (
		<Section>
			<SectionTitle>Report</SectionTitle>
			<SectionDescription>
				View reports that summarize security activity, incidents, and automation
				outcomes over time.
			</SectionDescription>

			<Outlet />
		</Section>
	)
}

function ReportPending() {
	return (
		<Section>
			<SectionTitle>Report</SectionTitle>

			<ReportSkeleton />
		</Section>
	)
}

function ReportSkeleton() {
	return (
		<div className="flex flex-col items-start justify-start gap-4">
			<Skeleton className="h-[170px] w-full" />
			<Skeleton className="h-[170px] w-full" />
			<Skeleton className="h-[170px] w-full" />
		</div>
	)
}
